var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--icon-color)",
    stroke: "var(--icon-color)",
    strokeWidth: 2,
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "800px",
    viewBox: "0 0 72 72",
    enableBackground: "new 0 0 72 72",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.568,17H46.501v-6.785C46.501,6.556,43.849,4,39.866,4h-8.138C27.615,4,25.5,6.613,25.5,10.214V17H10.432 C6.604,17,3.5,20.104,3.5,23.932v37.136c0,3.828,3.104,6.932,6.932,6.933h51.136c3.828,0,6.932-3.104,6.932-6.933h0.001V23.932 C68.501,20.104,65.396,17,61.568,17z M29.5,10.215C29.5,8.063,31.41,8,31.727,8h7.136c1.263,0,3.637,0.384,3.637,2.214V17h-13 V10.215z M61.568,64H10.432C8.813,64,7.5,62.688,7.5,61.068V43h3.13c0.553,0,1-0.447,1-1s-0.447-1-1-1H7.5V23.932 C7.5,22.313,8.813,21,10.432,21h51.136c1.619,0,2.932,1.313,2.932,2.932h0.001V41H42.499v-0.93c0-2.248-1.822-4.069-4.069-4.069 h-4.86c-2.248,0-4.07,1.821-4.07,4.069V41H16.631c-0.553,0-1,0.447-1,1s0.447,1,1,1H29.5v1.93c0,2.248,1.822,4.07,4.07,4.07h4.86 c2.248,0,4.07-1.822,4.07-4.07h-0.001V43h22.002v18.068C64.501,62.688,63.188,64,61.568,64z M40.5,40.07L40.5,40.07l-0.001,4.859 c0,1.143-0.926,2.07-2.069,2.07h-4.86c-1.143,0-2.07-0.928-2.07-2.07V40.07c0-1.143,0.926-2.069,2.07-2.069h4.86 C39.573,38.001,40.5,38.926,40.5,40.07z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.05673b96e650a787f54433f832141151.svg";
export { ForwardRef as ReactComponent };